import type { KeyValuePair } from "../engagementV2LinkTemplates";
import type { AllRouteEndpoints } from "../routeTypes";
import type { EngagementLinkTemplatesIdResult } from "./types";

export const engagementLinkTemplatesId = "/engagement/link_templates(/:id)";

export const getNewLinKTemplate = (existing?: EngagementLinkTemplatesIdResult): EngagementLinkTemplatesIdResult => {
  if (existing) {
    return { ...existing, id: null, name: `Copy of ${existing.name}` };
  }

  return {
    id: null,
    name: "",
    description: null,
    prepend: null,
    tag_names: [],
    territory_ids: [],
    context_property_tags: [],
    key_value_pairs: [getNewKvp()],
    auto_add_enabled: false,
  };
};

export const getNewKvp = (): KeyValuePair => {
  return {
    key: "",
    value: "",
    custom_value: false,
  };
};

export const engagementLinkTemplatesIdCacheKeys: AllRouteEndpoints[] = ["/engagement/link_templates(/:id)"];
